/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FormErrorHandler from '@avtechsoftware/react-component-library/src/components/common/FormErrorHandler/FormErrorHandler';
import AltErrorWrapper from '@avtechsoftware/react-component-library/src/components/common/FormErrorHandler/AltErrorWrapper/AltErrorWrapper';
import axios from 'axios';
import FormAlertBox from '@avtechsoftware/react-component-library/src/components/common/FormErrorHandler/FormAlertBox/FormAlertBox';
import LoginBox from '../LoginBox/LoginBox';
import RegistrationEmailSent from '../RegistrationEmailSent/RegistrationEmailSent';
import LoginBoxWrapper from '../LoginBoxWrapper/LoginBoxWrapper';

const API_URL = '/user/new/sign-up';
const CHECK_EMAIL_API_URL = '/gateway/check-email';
const API_CONFIG = {
  headers: {
    'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
  },
};

function RegisterSignInBox({
  referrer, isOrder, forceSignIn, isClosed, onPayAsGuest, isPayable,
}) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formErrors, setFormErrors] = useState([]);
  const [emailAddress, setEmailAddress] = useState('');
  const [isValidEmail, setIsValidEmail] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const [isRegisterEmailSent, setIsRegisterEmailSent] = useState(false);
  const [isExisting, setIsExisting] = useState(false);
  const [mfaRequired, setMfaRequired] = useState(false);

  const handleCheckEmail = () => {
    const formData = new FormData();
    formData.append('emailAddress', emailAddress);
    return axios.post(CHECK_EMAIL_API_URL, formData, API_CONFIG);
  };

  const handleSubmitRegistrationEmail = (e) => {
    e.preventDefault();
    setFormErrors([]);
    setIsSubmitting(true);
    const formData = new FormData();
    formData.append('emailAddress', emailAddress);
    formData.append('referrer', referrer);
    if (!isValidEmail) {
      setFormErrors([{ field: 'emailAddress', message: 'Invalid email address.' }]);
      setIsSubmitting(false);
      return;
    }
    axios.post(API_URL, formData, API_CONFIG)
      .then((response) => {
        if (response.data.success) {
          if (response.data.data.userExists === 1) {
            const { samlConfigName } = response.data.data;
            if (samlConfigName !== undefined) {
              window.location = `${window.location.origin}/auth/saml/login/${response.data.data.samlConfigName}`;
              return;
            }
            // handle user exists and check MFA
            return handleCheckEmail()
              .then((r) => {
                if (r.data.success) {
                  if (r.data.data.mfaRequired) {
                  // mfa login
                    setMfaRequired(true);
                  }
                  setIsExisting(true);
                }
              });
          } if (response.data.data.userExists === 0) {
            // registration email sent
            setIsRegisterEmailSent(true);
          }
        } else {
          setFormErrors([...response.data.data]);
        }
      })
      .catch((err) => {
        setFormErrors([{ message: err.message }]);
      })
      .finally(() => setIsSubmitting(false));
  };

  const handleSetLogin = () => {
    setEmailAddress('');
    setIsSubmitting(false);
    setFormErrors([]);
    setIsLogin(true);
  };

  React.useEffect(() => {
    if (forceSignIn) {
      handleSetLogin();
    }
  }, []);

  if (isRegisterEmailSent) {
    return <RegistrationEmailSent isOrder={isOrder} />;
  }
  if (isLogin) {
    return (
      <LoginBoxWrapper
        setIsLogin={setIsLogin}
      />
    );
  }
  if (isExisting) {
    return (
      <div className="card bg-light" style={{ minHeight: '4rem', maxWidth: '45rem' }}>
        <h5 className="card-header">{isOrder ? 'Submit Payment' : 'Place your Order'}</h5>
        <div className="card-body">
          <div className="pb-3">
            <h5 className="card-title">
              Good News! You are Already Registered.
            </h5>
            <div className="card-text">
              Enter your password and click login to access your account.
            </div>
          </div>
          <LoginBox
            isExistingUser
            existingEmail={emailAddress}
            isMfaRequired={mfaRequired}
          />
        </div>
      </div>
    );
  }

  /* istanbul ignore next */
  return (
    <div className="card bg-light" style={{ minHeight: '4rem', maxWidth: '45rem' }}>
      <h5 className="card-header">{isOrder ? 'Submit Payment' : 'Place your Order'}</h5>
      <div className="card-body">
        <FormErrorHandler errorList={formErrors} fieldList={['emailAddress']}>
          <form>
            <FormAlertBox />
            { !isClosed && isPayable
                && (
                <>
                  <div className="row mb-3">
                    <div className="col">
                      <div>
                        <button
                          type="button"
                          id="pay-as-guest"
                          className="btn btn-primary"
                          onClick={onPayAsGuest}
                        >
                          Pay as Guest
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col">
                      or
                    </div>
                  </div>
                </>
                )}
            <div className="row">
              <div className="col-xs-12 col-sm-8 col-lg-7">
                <div className="form-group mb-3">
                  <AltErrorWrapper fieldId="emailAddress">
                    <input
                      type="email"
                      id="email-address"
                      className="form-control w-100"
                      placeholder="Email address"
                      aria-label="email"
                      onChange={(e) => {
                        setIsValidEmail(e.target.validity.valid);
                        setEmailAddress(e.target.value);
                      }}
                      value={emailAddress}
                      disabled={isSubmitting}
                      required
                    />
                  </AltErrorWrapper>
                </div>
              </div>
              <div className="col">
                <div>
                  <button
                    type="submit"
                    id="submit"
                    className="btn btn-primary"
                    disabled={isSubmitting}
                    onClick={handleSubmitRegistrationEmail}
                  >
                    {isSubmitting ? 'Requesting Account...' : 'Register'}
                  </button>
                </div>
              </div>
            </div>
            {!isExisting && (
            <>
              <span className="text-fs-1 text-nowrap">
                {' '}
                <button id="set-login" type="button" className="btn p-0" onClick={handleSetLogin}>
                  {' '}
                  <small className="text-muted font-italic">
                    Already have an account?
                    {' '}
                    <a href="#" onClick={(e) => e.preventDefault()}>Sign in.</a>
                  </small>
                </button>
              </span>
            </>
            )}
          </form>
        </FormErrorHandler>
        <div className="mt-3">
          {
        isOrder
          ? (
            <i>
              Get a head-start; register at RoomAlert.com now!
              By the time you receive your products, you&apos;ll
              be ready to start setting up alerts, reports, and more.
            </i>
          )
          : (
            <i>
              Get a head-start: register at RoomAlert.com now!
              By the time you place your order and receive your products, you&apos;ll
              be ready to start setting up alerts, reports, and more.
            </i>
          )
       }
        </div>
      </div>
    </div>
  );
}

RegisterSignInBox.defaultProps = {
  isClosed: false,
  isPayable: true,
};

RegisterSignInBox.propTypes = {
  referrer: PropTypes.string.isRequired,
  isOrder: PropTypes.bool.isRequired,
  isClosed: PropTypes.bool,
  forceSignIn: PropTypes.bool.isRequired,
  onPayAsGuest: PropTypes.func.isRequired,
  isPayable: PropTypes.bool,
};

export default RegisterSignInBox;
